import React, { useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import styles from './StickyReportBar.module.css';

interface StickyReportBarProps {
    title: string;
    slug: string;
    contentId: string;
    reportId?: string;
    isVisible: boolean;
    onHeightChange?: (height: number) => void;
    reportPrice?: number;
    discountedPrice?: number;
    coverImage?: string;
    onDownloadSample?: () => void;
}

const StickyReportBar: React.FC<StickyReportBarProps> = ({
    title,
    slug,
    contentId,
    reportId,
    isVisible,
    onHeightChange,
    reportPrice,
    discountedPrice,
    coverImage,
    onDownloadSample
}) => {
    const barRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!barRef.current || !onHeightChange) return;

        const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
                onHeightChange(entry.target.clientHeight);
            }
        });

        observer.observe(barRef.current);
        return () => observer.disconnect();
    }, [onHeightChange]);

    const purchaseUrl = `/purchaseoptions?id=${reportId || contentId}&slug=${slug}`;
    const sampleRequestUrl = `/sample_request?id=${reportId || contentId}&name=${encodeURIComponent(title)}&type=smp&slug=${slug}`;

    return (
        <div
            ref={barRef}
            className={`${styles.stickyBar} ${isVisible ? styles.visible : ''}`}
        >
            <div className={styles.container}>
                <div className={styles.titleSection}>
                    <span className={styles.reportTitle} title={title}>
                        {title}
                    </span>
                </div>
                <div className={styles.ctaSection}>
                    {onDownloadSample ? (
                        <button className={styles.btnDownload} onClick={onDownloadSample}>
                            Download Free Sample
                        </button>
                    ) : (
                        <Link href={sampleRequestUrl} className={styles.btnDownload} target="_blank">
                            Download Free Sample
                        </Link>
                    )}
                    <Link href={purchaseUrl} className={styles.btnBuy}>
                        Buy Now
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default StickyReportBar;

